/* eslint-disable react/prop-types */
import React from 'react';
import cn from 'clsx';
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import classes from './SearchBox.module.scss';

const { Search } = Input;

const SearchBox = ({ className = '' }) => {
  return (
    <div className={cn(classes.wrapper, className)}>
      <Search
        placeholder="Search by Factory ID & Name, Tag"
        enterButton="Search"
        size="large"
        prefix={
          <SearchOutlined
            style={{
              fontSize: 16,
              color: '#1677ff',
            }}
          />
        }
      />
    </div>
  );
};

export default SearchBox;
